(function(){
    function contentSwitcher(){
        this.Init = function(){
            var $contentSwitcher = $('.js-contentSwitcher');
            var $advantages__item = $('.js-contentSwitcher_item', $contentSwitcher);
            var $bgSwitcherBlock = $('.js-contentSwitcher_bgSwitch',$contentSwitcher);
            var $textSliders= $('.js-textSlider-fade', $contentSwitcher);
            var $textSliderAlone = $('.advantages__textSliderBottom', contentSwitcher);
            
            $(document).click(function(e) {
                if (!$advantages__item.is(e.target)  && $advantages__item.has(e.target).length === 0) {
                    $textSliders.removeClass('animated fadeIn');
                    $textSliders.addClass('animated fadeOut');
                    
                    window.setTimeout(function(){
                        $advantages__item.removeClass('js-advantages__item_isShown');
                           $textSliders.removeClass('js-textSlider-isShown');
                           $textSliders.removeClass('animated fadeOut');
                       }, 400);
                   }
            });
        
            $advantages__item.on('click', function(e){
                var bgImageSrc = $(this).attr('data-imageSrc');
                var $textSlider_item = $('.js-textSlider-fade', $(this));    
                
                $advantages__item.removeClass('js-advantages__item_isShown');
                $(e.currentTarget).addClass('js-advantages__item_isShown');
                $contentSwitcher.css('background-image', 'url("'+bgImageSrc+'")');
                $contentSwitcher.imagesLoaded( { background: true }, function() {});
                
                $bgSwitcherBlock.removeClass('animated fadeIn').css('opacity', '0');
                $textSliderAlone.html($(this).html());
                
                window.setTimeout(function(){
                    $bgSwitcherBlock.css('background-image', 'url("'+bgImageSrc+'")').css('opacity', '1');;
                    $textSliders.removeClass('js-textSlider-isShown').removeClass('animated fadeIn');
                    $textSlider_item.addClass('js-textSlider-isShown').addClass('animated fadeIn');
                }, 500);
            });
        }            
    }
    
    proj.contentSwitcher = new contentSwitcher();
})();